var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2H1.5",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5H1.5",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5H8.5",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.75H5.5",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2H9.5",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.75H1.5",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 1C7.48295 1 7.59945 1 7.69135 1.03806C7.81385 1.0888 7.9112 1.18615 7.96195 1.30866C8 1.40055 8 1.51703 8 1.75V2.25C8 2.48297 8 2.59945 7.96195 2.69134C7.9112 2.81385 7.81385 2.9112 7.69135 2.96194C7.59945 3 7.48295 3 7.25 3C7.01705 3 6.90055 3 6.80865 2.96194C6.68615 2.9112 6.5888 2.81385 6.53805 2.69134C6.5 2.59945 6.5 2.48297 6.5 2.25V1.75C6.5 1.51703 6.5 1.40055 6.53805 1.30866C6.5888 1.18615 6.68615 1.0888 6.80865 1.03806C6.90055 1 7.01705 1 7.25 1Z",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.5C6.48295 8.5 6.59945 8.5 6.69135 8.53805C6.81385 8.5888 6.9112 8.68615 6.96195 8.80865C7 8.90055 7 9.01705 7 9.25V9.75C7 9.98295 7 10.0994 6.96195 10.1913C6.9112 10.3138 6.81385 10.4112 6.69135 10.462C6.59945 10.5 6.48295 10.5 6.25 10.5C6.01705 10.5 5.90055 10.5 5.80865 10.462C5.68615 10.4112 5.5888 10.3138 5.53805 10.1913C5.5 10.0994 5.5 9.98295 5.5 9.75V9.25C5.5 9.01705 5.5 8.90055 5.53805 8.80865C5.5888 8.68615 5.68615 8.5888 5.80865 8.53805C5.90055 8.5 6.01705 8.5 6.25 8.5Z",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.75C4.98297 4.75 5.09945 4.75 5.19135 4.78806C5.31385 4.83881 5.4112 4.93615 5.46195 5.05865C5.5 5.15055 5.5 5.26705 5.5 5.5V6C5.5 6.23295 5.5 6.34945 5.46195 6.44135C5.4112 6.56385 5.31385 6.6612 5.19135 6.71195C5.09945 6.75 4.98297 6.75 4.75 6.75C4.51703 6.75 4.40055 6.75 4.30866 6.71195C4.18615 6.6612 4.08881 6.56385 4.03806 6.44135C4 6.34945 4 6.23295 4 6V5.5C4 5.26705 4 5.15055 4.03806 5.05865C4.08881 4.93615 4.18615 4.83881 4.30866 4.78806C4.40055 4.75 4.51703 4.75 4.75 4.75Z",
    stroke: "#E8E8E8",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterInactive);
export default __webpack_public_path__ + "static/media/filter-inactive.9c921450bd15456b3cf430b431451cd4.svg";
export { ForwardRef as ReactComponent };